module.exports = __webpack_public_path__ + "static/img/late.fae9ed17.png";